import { render } from "./fit-guide-tab.vue?vue&type=template&id=69e136e4"
import script from "./fit-guide-tab.vue?vue&type=script&lang=js"
export * from "./fit-guide-tab.vue?vue&type=script&lang=js"

import exportComponent from "/__w/dryrobe.com-website/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__